export const MAP_PAGE_ZONES: { [key: string]: string } = {
  topBanner: 'hero',
  middleBanner: 'merchZone',
}

export const MAP_BANNER_TYPES: { [key: string]: string } = {
  topBanner: 'Hero',
  middleBanner: 'Banner',
}

export const MAP_CONTENTFUL_PAGE = 'Homepage'
